import { combineReducers } from 'redux'
import { List } from 'immutable'
import { LOAD_SITE_SCHEDULES, SITE_SCHEDULE_ADDED, SITE_SCHEDULE_REMOVED } from './action-types'

const addOrUpdate = (state, action) => {
  const indexOfExistingSite = state.findIndex(({ site }) => site === action.payload.site)

  if (indexOfExistingSite !== -1) {
    return state.set(indexOfExistingSite, action.payload)
  }

  return state.push(action.payload)
}


const schedulesReducer = (state = new List(), action) => {
  switch (action.type) {
    case LOAD_SITE_SCHEDULES:
      return new List(action.payload)
    case SITE_SCHEDULE_ADDED:
      return addOrUpdate(state, action)
    case SITE_SCHEDULE_REMOVED:
      return state.remove(state.findIndex(({ key }) => key === action.payload.key))
    default:
      return state
  }
}

export default combineReducers({ list: schedulesReducer })



// WEBPACK FOOTER //
// ./src/modules/schedules/reducer.js